import { render, staticRenderFns } from "./UserAdd.vue?vue&type=template&id=70ecede3&scoped=true&"
import script from "./UserAdd.vue?vue&type=script&lang=js&"
export * from "./UserAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ecede3",
  null
  
)

export default component.exports